// extracted by mini-css-extract-plugin
module.exports = {"status":"InventoryAdjustmentStatusPlate_status__3DO3-","icon":"InventoryAdjustmentStatusPlate_icon__2lH0A"};